import { AudienceBroadcastMessageStatus } from '@occc/graphql';

import { archivableStatuses } from '../messaging-campaigns-list/messaging-campaigns-list.constants';

export const getIsArchivableByStatus = (status?: AudienceBroadcastMessageStatus) => {
  if (!status) {
    return false;
  }

  return archivableStatuses.includes(status);
};
